import { METADATA_FILTER_MATCH_TYPE } from "@/constants/filter-types"

import type { MetadataFilter } from "@/types/MetadataFilter"

const ENTRY_SEP = ","
const FIELD_SEP = "|"

function encodePart(s: string): string {
  return s.replace(/%/g, "%25").replace(/\|/g, "%7C").replace(/,/g, "%2C")
}

function decodePart(s: string): string {
  return s.replace(/%2C/gi, ",").replace(/%7C/gi, "|").replace(/%25/g, "%")
}

export function serializeMetadataFilters(filters: MetadataFilter[]): string {
  if (!filters.length) {
    return ""
  }
  return filters
    .map((filter) => {
      const fields = [
        encodePart(filter.key),
        encodePart(filter.value),
        filter.matchType,
      ]
      if (filter.matchType === "ANY_OF") {
        fields.push(encodePart(JSON.stringify(filter.values ?? [])))
      }
      return fields.join(FIELD_SEP)
    })
    .join(ENTRY_SEP)
}

export function parseMetadataFilters(raw: string): MetadataFilter[] {
  if (!raw) {
    return []
  }
  const filters: MetadataFilter[] = []
  for (const entry of raw.split(ENTRY_SEP)) {
    const parts = entry.split(FIELD_SEP)
    const [key, value, matchType, encodedValues] = parts
    if (matchType === "ANY_OF") {
      let values: string[] = []
      try {
        const parsed: unknown =
          parts.length === 4 ? JSON.parse(decodePart(encodedValues)) : null
        if (
          Array.isArray(parsed) &&
          parsed.every((item) => typeof item === "string")
        ) {
          values = parsed
        }
      } catch {
        values = []
      }
      filters.push({
        key: decodePart(key),
        value: decodePart(value),
        matchType,
        values,
      })
      continue
    }
    if (
      parts.length !== 3 ||
      (matchType !== METADATA_FILTER_MATCH_TYPE.EQUALS &&
        matchType !== METADATA_FILTER_MATCH_TYPE.CONTAINS)
    ) {
      continue
    }
    filters.push({
      key: decodePart(key),
      value: decodePart(value),
      matchType,
    })
  }
  return filters
}
